export default "__VITE_ASSET__CcHD5d3c__"